import { Box, Skeleton } from '@fuegokit/react';
import { useEffect } from 'react';

import { EntryDetail } from './LastEntryDetails';
import { UserDetails } from './UserDetails';

const Loader = () => <Skeleton height={17} sx={{ marginBottom: 0 }} />;

export function LoadingItem() {
  useEffect(() => {
    const lastElement = document.querySelector('.users-loaders:last-child');
    if (lastElement) {
      lastElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'start',
      });
    }
  }, []);
  return (
    <div className="users-loaders">
      <UserDetails loading={true}>
        <Box
          display="grid"
          gridRowGap="20px"
          gridTemplateColumns="minmax(0, 1fr)"
          gridColumnGap="4px"
        >
          <EntryDetail label="Last Jira entry">
            <Loader />
          </EntryDetail>
          <EntryDetail label="Latest entry name">
            <Loader />
          </EntryDetail>
          <Box
            display="grid"
            gridTemplateColumns="minmax(0, 1fr) minmax(0, 1fr)"
            gridGap="20px"
          >
            <EntryDetail label="Started">
              <Loader />
            </EntryDetail>
            <EntryDetail label="Duration">
              <Loader />
            </EntryDetail>
            <EntryDetail label="Toggle workspace">
              <Loader />
            </EntryDetail>
            <EntryDetail label="Toggle project">
              <Loader />
            </EntryDetail>
          </Box>
        </Box>
      </UserDetails>
    </div>
  );
}

export const LoadingItems = function () {
  return (
    <>
      {Array.from({ length: 3 }).map((e, index) => {
        return <LoadingItem key={index} />;
      })}
    </>
  );
};
